/**
* @description: 上机/落机打卡地址管理
*/
<template>
    <div class="finance_box" ref="myElementRef">
        <div ref="searchBox">
            <hc-search :data="searchData" @serch="getSearch">
                <template #btns>
                <el-button
                    type="primary"
                    icon="Plus"
                    @click="$refs['addLocation'].open()"
                    >{{ t('common.add') }}</el-button
                >
                </template>
            </hc-search>
        </div>
        <!-- 表格 -->
        <div class="table_box">
            <hc-table :tableData="state.tableData" :column="state.tableHeader" :offsetHeight="state.offsetHeight"
                :maxPage="maxPage" @pageChange="pageChange" @limitChange="limitChange">
                <template #operation="scope">
                    <div class="btn_box_det">
                        <el-button class="opBtn" size="small" type="primary" link
                            @click="$refs['addLocation'].open(scope.row)">{{ t('common.edit') }}</el-button>
                    </div>
                </template>
            </hc-table>
        </div>
        <!-- 新增 -->
        <EditClockIn ref="addLocation" :title="state.title" @refresh="getSearch(searchData)" />
    </div>
</template>

<script setup>
import hcSearch from "@/components/hc-search/index.vue";
import hcTable from "@/components/hc-table/index.vue";
import { onMounted, reactive, ref, nextTick, onUnmounted } from "vue";
import EditClockIn from "./components/editClockIn.vue";
import { useAttendancePageI18n, t } from '@/composables/useAttendancePageI18n.js';

import { pageListApi } from "@/api/attendance/clockin.js";
import { listToMap } from "@/utils/utils";
const myElementRef = ref();
const searchBox = ref();
const addLocation = ref();


let page = ref(1);
let limit = ref(20);
let maxPage = ref(0);

const buildStatusOptions = () => ([
    { label: t('status.enabled'), value: 1 },
    { label: t('status.disabled'), value: 0 }
]);

const statusOptions = reactive(buildStatusOptions());

const searchData = reactive([
    { label: "", type: "input", value: "", field: 'keywords' },
]);

const buildColumns = () => ([
    { prop: "id", show: false, label: t('attendance.addressId') },
    { show: true, type: "index", label: t('table.index'), width: 80 },
    { prop: "location_name", show: true, label: t('attendance.locationName') },
    { prop: "description", show: true, label: t('attendance.locationDesc') },
    { prop: "longitude", show: true, label: t('attendance.longitude') },
    { prop: "latitude", show: true, label: t('attendance.latitude') },
    { prop: "status", show: true, label: t('field.status') },
    { prop: "operation", show: true, label: t('table.operation') },
]);

const applyLabels = () => {
    searchData[0].label = t('field.keywords');
    Object.assign(statusOptions, buildStatusOptions());
    state.column = buildColumns();
    tableHeaderFn();
};

useAttendancePageI18n(applyLabels);

const state = reactive({
    title: "",
    column: buildColumns(),
    offsetHeight: 0,
    tableHeader: [],
    tableData: []
});

const init = () => {
    getSearch(searchData)
};

const offHeighths = () => {
    if (myElementRef.value) {
        state.offsetHeight =
            myElementRef.value?.offsetHeight - 90 - searchBox.value?.offsetHeight;
    }
};

const pageChange = (currentPage) => {
    page.value = currentPage;
    getSearch(searchData)
}

const limitChange = (currentLimit) => {
    limit.value = currentLimit;
    getSearch(searchData)
}

onMounted(() => {
    try {
        applyLabels();
        nextTick(() => {
            offHeighths();
        });
        window.onresize = () => {
            nextTick(() => {
                offHeighths();
            });
        };
        tableHeaderFn();
        init();
    } catch { }
});

onUnmounted(() => {
    window.onresize = null;
});

const getSearch = (params) => {
    const requestParams = JSON.stringify({
        page: page.value,
        limit: limit.value,
        ...listToMap(params, { value: 'value', key: 'field' })
    })
    state.loading = true

    pageListApi(requestParams).then(res => {
        maxPage.value = res?.maxPage ?? 0;
      state.tableData = res?.data?.map(item => {
        return {
         ...item,
          status: listToMap(statusOptions, {})[item.status],
        }
      })
    }).finally(() => {
    state.loading = false
  })
};

const tableHeaderFn = () => {
    state.tableHeader = state.column.filter((v) => {
        if (v.show) {
            return v.show == true;
        } else {
            v.show = false;
        }
    });
};
</script>

<style lang="less" scoped>
.finance_box {
    flex: 1;
    overflow: auto;
    background-color: #fff;
    border-radius: 6px;
    padding: 10px;
    margin-right: 10px;
}

.btn_box {
    height: 40px;
    display: flex;
}

.table_box {
    width: 100%;
}

/deep/.el-button-group .el-button--primary:first-child {
    background-color: #1e6aed;
    border: none;
}

.serBtn {
    margin-left: 10px;
    background-color: #f0f0f0;
    color: #000;
    border: none;
}

.serBtn:hover {
    background-color: #f0f0f0;
    color: #000;
}

.opBtn {
    margin: 0 10px 0 0;
}

.opBtn:hover {
    color: #e6a755;
}
</style>
